/**
 * Regeln für die beiden Kundenformulare — Bestellbestätigung und
 * Entwurfsfreigabe.
 *
 * Eigene Datei, damit sie ohne React-Router und Firebase prüfbar ist — die
 * Komponente zieht beides herein, und Jest kommt mit der Modulauflösung von
 * react-router-dom nicht zurecht.
 */

/**
 * Fehlt bei einem Änderungswunsch die Beschreibung?
 *
 * Bestellung #4189459291 (02.10.2026) kam mit `orderDecision: "modification"`
 * und `orderFeedback: null` an — null Zeichen. Das Entwurfsformular hatte
 * dieselbe Lücke (Tobias am 02.10.: „auch hier sollten Änderungswünsche
 * nicht abgeschickt werden können"). Für uns nicht bearbeitbar (wir
 * wissen nicht, was zu ändern ist), und für die Kundin eine Sackgasse: sie
 * wartet auf eine Rückmeldung zu etwas, das nirgends steht.
 *
 * Abgesichert war es an KEINER Stelle: Textfeld ohne `required`, Knopf nur
 * während des Sendens gesperrt, `handleSubmit` schaute den Text nicht an, und
 * die Cloud Function schrieb `orderFeedback || null`.
 *
 * Nur Leerzeichen zählen nicht als Beschreibung.
 */
export const fehlenderAenderungstext = (decision, feedback) =>
  decision === "modification" && !String(feedback || "").trim();
